import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubscribedMap } from "../../../Pages/SubscribedMap/ISubscribed";

export const EditSubscribedMapSlice = createSlice({
  name: "EditSubscribedMapSlice",
  initialState: {} as IReduxState<ISubscribedMap>,
  reducers: {
    EditSubscribedMap: (state, _: PayloadAction<ISubscribedMap>) => {
      state.isLoading = true;
    },
    successEditSubscribedMap: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditSubscribedMap: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditSubscribedMapResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EditSubscribedMap,
  failureEditSubscribedMap,
  successEditSubscribedMap,
  clearEditSubscribedMapResponse,
} = EditSubscribedMapSlice.actions;

export default EditSubscribedMapSlice.reducer;
